import { t } from '../i18n/lingua'

/**
 * Come si prepara Hyper-V per CENSO, per ciascuna modalità di connessione
 * (WinRM, WMI, SCVMM): l'utente, i gruppi, le porte, la prova. Accanto al
 * modulo della credenziale «Microsoft Hyper-V», chiusa di default. Il testo
 * completo è in docs/operations/hyperv.md.
 */
export function GuidaHyperV() {
  return (
    <details className="guida-chiave">
      <summary>{t('Come preparo Hyper-V per CENSO (WinRM, WMI o SCVMM)?')}</summary>
      <div className="guida-chiave__corpo">
        <p>
          {t(
            'CENSO legge Hyper-V senza installare nulla sugli host: la sonda si collega con la modalità scelta nella credenziale ed esegue soltanto letture. Scegli una modalità: WinRM se è attivo (la più completa), WMI se WinRM è spento, SCVMM se hai System Center Virtual Machine Manager.',
          )}
        </p>
        <h4>{t('A) L’utente')}</h4>
        <ol>
          <li>{t('Un utente di dominio dedicato (per esempio «censo-hyperv»), non un amministratore di dominio.')}</li>
          <li>
            {t(
              'Su ogni host: membro di «Hyper-V Administrators» (per leggere le VM) e di «Remote Management Users» (per aprire la sessione WinRM).',
            )}
          </li>
          <li>
            {t(
              'Se gli host sono in cluster: lettura sul cluster, con «Grant-ClusterAccess -User DOMINIO\\censo-hyperv -ReadOnly» su un nodo.',
            )}
          </li>
        </ol>
        <h4>{t('B) WinRM (consigliata)')}</h4>
        <ol>
          <li>
            {t(
              'Su ogni host WinRM deve rispondere: «Enable-PSRemoting» (HTTP 5985) oppure un listener HTTPS sulla 5986 («winrm quickconfig -transport:https» con un certificato del server).',
            )}
          </li>
          <li>{t('Firewall: dalla sonda verso ogni host, TCP 5986 (o 5985 se scegli «WinRM in chiaro»).')}</li>
          <li>
            {t(
              'Nella credenziale scrivi il nome del cluster o uno qualunque dei nodi: la sonda chiede al cluster l’elenco dei nodi e si collega a ciascuno direttamente (ogni nodo conosce solo le VM che ospita). «Solo gli host indicati» disattiva questo passo.',
            )}
          </li>
        </ol>
        <h4>{t('C) WMI, senza WinRM')}</h4>
        <ol>
          <li>
            {t(
              'Firewall: dalla sonda verso ogni host, TCP 135 e le porte RPC dinamiche (49152–65535); sugli host le regole «Windows Management Instrumentation (DCOM-In)» e «(WMI-In)».',
            )}
          </li>
          <li>
            {t(
              'L’utente, oltre ai gruppi del passo A, va in «Distributed COM Users» e deve avere «Enable Account» e «Remote Enable» sui namespace root\\virtualization\\v2, root\\cimv2 e root\\MSCluster (wmimgmt.msc → Proprietà → Sicurezza).',
            )}
          </li>
          <li>{t('Via WMI mancano le dimensioni dei dischi virtuali: per leggerle servirebbe invocare metodi, e CENSO si limita a interrogare.')}</li>
        </ol>
        <h4>{t('D) System Center VMM')}</h4>
        <ol>
          <li>{t('Nella credenziale scrivi il server VMM: la sonda apre WinRM verso di lui (passo B, ma solo verso il server VMM).')}</li>
          <li>
            {t(
              'In VMM (Settings → User Roles) dai all’utente il ruolo «Read-Only Administrator», con ambito sui gruppi host da inventariare.',
            )}
          </li>
          <li>{t('Host e VM vSphere gestiti da VMM vengono saltati: li legge il connettore VMware, così non compaiono due volte.')}</li>
        </ol>
        <h4>{t('E) La prova e cosa trovi')}</h4>
        <ol>
          <li>
            {t(
              'Da un PC Windows: «Enter-PSSession hv01 -Credential DOMINIO\\censo-hyperv», poi «Get-VM». Se risponde, risponde anche a CENSO.',
            )}
          </li>
          <li>
            {t(
              'Dopo il job, in Ambienti virtuali trovi l’ambiente Hyper-V: host, cluster, VM (generazione, memoria dinamica, dischi, schede con VLAN e indirizzi), commutatori virtuali e volumi/CSV come datastore.',
            )}
          </li>
          <li>
            {t(
              'Gli indirizzi IP delle VM li dà il servizio d’integrazione «Scambio dati (KVP)» dentro l’ospite: se è spento, la VM si riconosce solo per MAC, e il rapporto del job lo dice.',
            )}
          </li>
        </ol>
      </div>
    </details>
  )
}
